import type { SVGProps } from "react";

export function IconBlackBarrier(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3108 27.25H44.1894L57.6894 13.75H38.8108L25.3108 27.25ZM36.6894 13.75L23.1894 27.25H16.75V34.75H17.6894L16.75 35.6894V35.75H16.6894L6.25 46.1894V34.75H15.25V27.25H6.31076L19.8108 13.75H36.6894ZM17.6894 13.75H6.25V25.1894L17.6894 13.75ZM57.75 15.8108L46.3108 27.25H47.25V34.75H39.8108L26.3108 48.25H44.1894L57.6894 34.75H48.75V27.25H57.75V15.8108ZM15.25 48.25H6.31076L19.8108 34.75H37.6894L24.1894 48.25H16.75V57.75H15.25V48.25ZM48.75 48.25V58H47.25V48.25H46.3108L57.75 36.8108V48.25H48.75Z"
        fill="#23232C"
      />
      <circle cx="48" cy="10" r="3" stroke="#23232C" strokeWidth="1.5" />
      <circle cx="16" cy="10" r="3" stroke="#23232C" strokeWidth="1.5" />
    </svg>
  );
}
